<template>
  <div v-if="coverTypeQuestion">
    <div
      class="d-flex flex-column align-center white rounded-lg elevation-3 pa-md-15 pa-sm-4 mx-md-2 mx-3"
    >
      <BaseButton
        v-if="showBackToFactFindButton"
        text="Back to 'Fact find'"
        flat
        ripple
        class="font-weight-bold mt-2 d-flex back-btn align-self-start"
        icon="mdi-chevron-left"
        color="accent"
        small
        @click="handleBackToFactFind"
      />
      <h1
        class="mt-14 mb-13 text-center text-sm-h5 font-weight-bold text-md-h4 text--title"
      >
        What type of Landlord's Insurance do you need?
      </h1>
      <ValidationObserver
        ref="obs"
        v-slot="{ invalid, validate }"
        class="align-self-stretch"
      >
        <v-form
          @submit.prevent="validate().then(() => handleContinue(invalid))"
        >
          <div class="d-flex flex-column align-center control-container">
            <ValidationProvider
              v-slot="{ errors }"
              :rules="{
                required: {
                  required: true,
                  fieldLabel: 'Type of Landlord\'s Insurance',
                },
              }"
            >
              <v-radio-group
                row
                hide-details="auto"
                class="radioImage radio__wrapper mt-0 pt-0"
                data-uiid="CoverType"
                v-model="coverTypeQuestion.Value"
                :error-messages="errors"
              >
                <v-card
                  :ripple="false"
                  class="elevation-0"
                  :class="[
                    coverTypeQuestion.Value === option.value
                      ? 'radioImage--active'
                      : '',
                  ]"
                  :data-uiid="option.dataUiid"
                  v-for="(option, index) in options"
                  :key="index"
                  @click="getValue(option.value)"
                >
                  <div class="radioImage__outer">
                    <div class="radioImage__inner">
                      <div class="img__wrapper">
                        <v-img
                          :src="require(`@/assets/icons/${option.image.Path}`)"
                          :max-width="option.image.maxWidth"
                          :max-height="option.image.maxHeight"
                          :alt="option.image.imageName"
                          class="coverIcons"
                        ></v-img>
                      </div>
                      <label
                        class="font-weight-bold"
                        :class="
                          $vuetify.breakpoint.lgAndUp ? 'font-24' : 'font-16'
                        "
                        v-html="option.text"
                      ></label>
                    </div>
                  </div>
                </v-card>
              </v-radio-group>
            </ValidationProvider>
            <!--Help text-->
            <div class="cover-help-block">
              <span
                class="d-flex"
                :class="[
                  $vuetify.breakpoint.lgAndUp ? 'align-center' : 'align-start',
                ]"
              >
                <div class="cover-help-icon__wrapper">
                  <v-icon
                    color="#106175"
                    :size="18"
                    class="mr-1 text-cursor"
                    @click="showModal('DialogContentLandlordCoverType')"
                    >mdi-help-circle</v-icon
                  >
                </div>
                <a @click="showModal('DialogContentLandlordCoverType')">
                  <span>How do I know what cover is right for me?</span></a
                >
              </span>
            </div>
            <v-btn
              type="submit"
              :ripple="false"
              depressed
              color="mustard"
              class="mt-9 mt-md-13 font-weight-bold font-20 text-uppercase continueBtn continueBtnText"
              rounded
              x-large
              >CONTINUE</v-btn
            >
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { isQuilterSpecific } from "@/common/question-set";
import { scrollTop } from "@/common/utils";
import BaseButton from "@/components/BaseComponents/BaseButton";
import { ROUTE_NAME } from "@/constants/route.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "D2CLandlordCoverTypePage",
  components: {
    BaseButton,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      options: [
        {
          text: "Buildings &<br>contents",
          image: {
            Path: "ic_buildings_and_contents.svg",
            maxWidth: "112px",
            imageName: "Buildings And Contents",
            maxHeight: "auto",
          },
          value: "BuildingsAndContents",
          dataUiid: "CoverType_BuildingsAndContents",
        },
        {
          text: "Buildings<br>only",
          image: {
            Path: "ic_buildings.svg",
            maxWidth: "78px",
            imageName: "Buildings Only",
            maxHeight: "auto",
          },
          value: "BuildingsOnly",
          dataUiid: "CoverType_BuildingsOnly",
        },
      ],
      coverTypeQuestion: null,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["questionMap"]),
    ...mapGetters(QUESTIONS_MODULE, ["qsId"]),
    showBackToFactFindButton() {
      return isQuilterSpecific(this.qsId);
    },
  },
  mounted() {
    this.coverTypeQuestion = this.questionMap.CoverType;
    if (this.coverTypeQuestion && !this.coverTypeQuestion.Value) {
      this.coverTypeQuestion.Value = "BuildingsAndContents";
    }
    // Prevent the user from skipping Your Details step
    this.setRestoringLastStep(false);
    scrollTop();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["setRestoringLastStep"]),
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    getValue(value) {
      this.coverTypeQuestion.Value = value;
    },
    handleContinue(invalid) {
      if (!invalid) {
        this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS });
      }
    },
    handleBackToFactFind() {
      this.$router.push("/factfind");
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-lg.elevation-3 {
  margin-top: 24px !important;
  margin-bottom: 80px !important;
}
.radioImage.radio__wrapper {
  .v-card {
    min-height: 216px !important;
    min-width: 204px !important;
    position: relative !important;
    border-radius: 13.5px;
    border: solid 1px $stepper-inactive !important;
    transition: border-width 0.1s linear;
    &.radioImage--active {
      border: solid 4px $cyan-darken-4 !important;
    }
  }
  :deep(.v-input--radio-group__input) {
    gap: 14px;
  }
  .img__wrapper {
    min-height: 73px;
    margin-bottom: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}
.text--title.text-md-h4 {
  font-size: 32px !important;
  color: $black-2;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal !important;
  text-align: left;
}
.continueBtn {
  max-width: 440px;
  width: calc(100% - 24px);
  height: 60px !important;
  margin-bottom: 110px !important;
}
.continueBtnText {
  color: #272727;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
}
.back-btn {
  margin-top: -21px !important;
  margin-left: -46px !important;
  margin-bottom: 25px !important;
}
.cover-help-block {
  padding-top: 38px;
  text-align: center;
  margin-bottom: -5px; // override continue default continue button margin
  position: relative;

  a {
    display: flex;
    align-items: baseline;
    span {
      font-weight: 600;
      color: #106175;
      font-size: 18px;
      text-align: center;
    }
  }
}

.radio-button-section {
  height: 50%;
}
@media screen and (max-width: 992px) {
  .back-btn {
    margin-top: -4px !important;
    margin-left: -20px !important;
    margin-bottom: 10px !important;
  }
}
@media screen and (max-width: 640px) {
  .cover-help-block {
    width: 279px;
  }
}
@media screen and (max-width: $grid-breakpoints-md) {
  .radioImage.radio__wrapper {
    .img__wrapper {
      margin-bottom: 9px;
      min-height: auto;
      max-width: 91px;
    }
    .v-card {
      min-height: 144px !important;
      min-width: 134px !important;
    }

    .radioImage__inner label {
      line-height: 18px !important;
    }
  }

  .text--title.text-md-h4 {
    font-size: 28px !important;
  }
}
@media screen and (min-width: $grid-breakpoints-lg) {
  .rounded-lg.elevation-3 {
    margin-top: 30px !important;
    margin-bottom: 162px !important;
  }
  .continueBtn {
    margin-bottom: 144px !important;
  }
}
</style>
